/**
* @Author: zachalam
* @Date:   2017-04-03T16:28:55-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-04-03T16:28:55-07:00
*/



let initialState = {
  mail_current_page: 0,
  mail_total_pages: 0,
  fav_current_page: 0,
  fav_total_pages: 0,
  search_current_page: 0,
  search_total_pages: 0,
  triplikes_current_page: 0,
  triplikes_total_pages: 0,
  search_scroll_height: 0,
  blocked_current_page: 0,
  blocked_total_pages: 0,
};

const meta = (state = initialState, action) => {
  switch(action.type) {
    case 'STORE_META':
      return {
        ...state,
        ...action.payload
      }
    default:
      return state;
  }
}



export default meta;



// WEBPACK FOOTER //
// ./src/reducers/meta.js